// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import apiDataReducer from './slicers/apiSlicer';
import nisysReducer from '../logic/nisys_slice';

export const store = configureStore({
  reducer: {
    apiData: apiDataReducer,
    nisys: nisysReducer,
  },
});